export default "__VITE_ASSET__X0J0VmbE9Y6eehvFaNyYWw__ 480w, __VITE_ASSET__nfSYHBnrEfg1A82Bgp7Mrg__ 745w";